import { render, staticRenderFns } from "./RiskMessageCard.html?vue&type=template&id=3b5e5cda&external"
import script from "./RiskMessageCard.vue?vue&type=script&lang=js"
export * from "./RiskMessageCard.vue?vue&type=script&lang=js"
import style0 from "./RiskMessageCard.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports